import React from 'react'
import { observer, inject } from 'mobx-react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'hljd'
import style from './style.module.less'

export default inject('certificationStore')(
  observer(({ certificationStore: { nevigateToMerchantSchool } }) => (
    <span>
      品牌代理认证&nbsp;
      <Tooltip>
        <span className={style.title} onClick={nevigateToMerchantSchool}>
          <QuestionCircleOutlined />&nbsp;品牌代理认证是什么？
        </span>
      </Tooltip>
    </span>
  ))
)
